import { useToast } from '#imports'
import { computed } from 'vue'
import type { Product, Variant } from '../models/product.js'
import { useCheckoutStore } from '~/stores/checkout.js'

export const useCart = () => {
  const toast = useToast()
  const storage = useCheckoutStore()

  const initializeCart = async() => {
    await storage.initializeCart()
  }
  const addToCart = (product: Product, quantity: number = 1, variant?: Variant | null) => {
    storage.addToCart(product, quantity, variant)

    toast.success({ title: 'Added', message: `${product.name} added to cart.`, position: 'topCenter' })
  }
  const removeFromCart = (productId: string) => {
    const product = storage.items.find((item: { id: string }) => item.id === productId)
    storage.removeFromCart(productId)
    toast.success({ title: 'Removed', message: `${product?.product.name} removed from cart.`, position: 'topCenter' })
  }
  const clearCart = () => {
    storage.clearCart()
    toast.success({ title: 'Cart Cleared', message: 'All items have been removed from your cart.', position: 'topCenter' })
  }
  const getCountOfProductInCart = (productId: string) => {
    const quantity = storage.items.find((item: { product: { id: string } }) => item.product.id === productId)

    return quantity?.quantity ?? 0
  }
  return {
    getCountOfProductInCart,
    cartCount: computed(() => storage.cartCount),
    cartTotal: computed(() => storage.cartTotal),
    items: computed(() => storage.items),
    initializeCart,
    addToCart,
    removeFromCart,
    clearCart,
  }
}
